import { frontendURL } from '../../../helper/URLHelper';
import ContactsIndex from './pages/ContactsIndex.vue';
import ContactManageView from './pages/ContactManageView.vue';
import { FEATURE_FLAGS } from '../../../featureFlags';
import store from 'dashboard/store';
import { ensureContactsDefaultSidebarPage } from 'dashboard/helper/sidebarPagePreload';

const commonMeta = {
  featureFlag: FEATURE_FLAGS.CRM,
  permissions: ['administrator', 'agent', 'contact_manage'],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/contacts'),
    component: ContactsIndex,
    meta: commonMeta,
    children: [
      {
        path: '',
        name: 'contacts_dashboard_index',
        component: ContactsIndex,
        beforeEnter: async to => {
          if (
            Number(to.query.page || 1) !== 1 ||
            to.query.search ||
            store.getters['contacts/getAppliedContactFilters']?.length
          )
            return;

          await ensureContactsDefaultSidebarPage({
            store,
            accountId: to.params.accountId,
            sortAttr:
              store.getters.getUISettings?.contacts_sort_by ||
              'last_activity_at',
          });
        },
        meta: { ...commonMeta, pagePermission: 'page_contacts_all' },
      },
      {
        path: 'segments/:segmentId',
        name: 'contacts_dashboard_segments_index',
        component: ContactsIndex,
        meta: { ...commonMeta, pagePermission: 'page_contacts_segments' },
      },
      {
        path: 'labels/:label',
        name: 'contacts_dashboard_labels_index',
        component: ContactsIndex,
        meta: { ...commonMeta, pagePermission: 'page_contacts_labels' },
      },
      {
        path: 'active',
        name: 'contacts_dashboard_active',
        component: ContactsIndex,
        meta: { ...commonMeta, pagePermission: 'page_contacts_active' },
      },
    ],
  },
  {
    path: frontendURL('accounts/:accountId/contacts/:contactId'),
    component: ContactManageView,
    meta: commonMeta,
    children: [
      {
        path: '',
        name: 'contacts_edit',
        component: ContactManageView,
        meta: { ...commonMeta, pagePermission: 'page_contacts_all' },
      },
      {
        path: 'segments/:segmentId',
        name: 'contacts_edit_segment',
        component: ContactManageView,
        meta: { ...commonMeta, pagePermission: 'page_contacts_segments' },
      },
      {
        path: 'labels/:label',
        name: 'contacts_edit_label',
        component: ContactManageView,
        meta: { ...commonMeta, pagePermission: 'page_contacts_labels' },
      },
    ],
  },
];
